import PropTypes from 'prop-types'

import { useStyletron } from 'baseui'
import Icon from 'baseui/icon/icon'

const IconTelecom = ({ color, overrides, ref, size, title }) => {
  const [, theme] = useStyletron()

  title = title ?? 'Telecom'
  size = size ?? 16
  color = color ?? theme.colors.primary

  return (
    <Icon viewBox='2 2 33 45' ref={ref} title={title} size={size} color={color} overrides={overrides}>
      <title>{title}</title>
      <path
        d="M45.5 -2H43.5V0H45.5V-2ZM12.25 42.424C14.6833 43.4747 17.2667 44 20 44H28C28.5667 44 29.0413 43.808 29.424 43.424C29.808 43.0413 30 42.5667 30 42C30 41.4333 29.808 40.9587 29.424 40.576C29.0413 40.192 28.5667 40 28 40H20C15.6333 40 11.8747 38.4247 8.724 35.274C5.57467 32.1247 4 28.3667 4 24C4 19.6333 5.57467 15.8747 8.724 12.724C11.8747 9.57467 15.6333 8 20 8C24.3667 8 28.1247 9.57467 31.274 12.724C34.4247 15.8747 36 19.6333 36 24V26.9C36 27.8667 35.7 28.6247 35.1 29.174C34.5 29.7247 33.8 30 33 30C32.2 30 31.5 29.7247 30.9 29.174C30.3 28.6247 30 27.8667 30 26.9V24C30 21.2333 29.0253 18.8747 27.076 16.924C25.1253 14.9747 22.7667 14 20 14C17.2333 14 14.8753 14.9747 12.926 16.924C10.9753 18.8747 10 21.2333 10 24C10 26.7667 10.9753 29.1247 12.926 31.074C14.8753 33.0247 17.2333 34 20 34C21.4 34 22.7087 33.742 23.926 33.226C25.142 32.7087 26.2 32 27.1 31.1C27.7667 31.9667 28.6167 32.6667 29.65 33.2C30.6833 33.7333 31.8 34 33 34C34.9667 34 36.6253 33.308 37.976 31.924C39.3253 30.5413 40 28.8667 40 26.9V24C40 21.2333 39.4747 18.642 38.424 16.226C37.3747 13.8087 35.9413 11.692 34.124 9.876C32.308 8.05867 30.1913 6.62467 27.774 5.574C25.358 4.52467 22.7667 4 20 4C17.2667 4 14.6833 4.52467 12.25 5.574C9.81667 6.62467 7.692 8.05867 5.876 9.876C4.05867 11.692 2.62533 13.8087 1.576 16.226C0.525333 18.642 0 21.2333 0 24C0 26.7333 0.525333 29.3167 1.576 31.75C2.62533 34.1833 4.05867 36.308 5.876 38.124C7.692 39.9413 9.81667 41.3747 12.25 42.424ZM24.25 28.25C23.0833 29.4167 21.6667 30 20 30C18.3333 30 16.9167 29.4167 15.75 28.25C14.5833 27.0833 14 25.6667 14 24C14 22.3333 14.5833 20.9167 15.75 19.75C16.9167 18.5833 18.3333 18 20 18C21.6667 18 23.0833 18.5833 24.25 19.75C25.4167 20.9167 26 22.3333 26 24C26 25.6667 25.4167 27.0833 24.25 28.25Z"
      />
    </Icon>
  )
}

IconTelecom.propTypes = {
  color: PropTypes.string,
  overrides: PropTypes.object,
  ref: PropTypes.object,
  size: PropTypes.number,
  title: PropTypes.string,
}

export default IconTelecom
